export const imageUrl = (url) => {
  let img = url
  let dotIndex
  if (img) {
    // 이미지 서버에 있는 파일인 경우 모바일 사이즈에 맞게 리사이징 된 이미지를 가져오기 위해 확장자 앞에 _2를 붙인다.
    if (
      img.startsWith('http://img.wavve.com') ||
      img.startsWith('img.wavve.com')
    ) {
      dotIndex = img.lastIndexOf('.')
      if (dotIndex > -1) img = img.slice(0, dotIndex) + '' + img.slice(dotIndex)
    }
    return img.startsWith('http') ? img : location.protocol + '//' + img
  }
  return ''
}
export const url = (url) => location.protocol + '//' + url
